import { memo, useEffect, useState, useCallback } from "react";
import Form from "../../components/Form";
import { getOwners, getInspectors, getAnimalsByGender, addUdder } from "../../api/index.js";
import { useSnackbar } from "../../utils/index.js";
import useSelectStyles from "../../components/styles/Select";
import Spinner from "../../components/Spinner";
import { Typography, Box, Button } from "@mui/material";


const UdderCreate = () => {
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [fetchedInspectors, setFetchedInspectors] = useState([]);
    const [inspectorsDropdownValues, setInspectorsDropdownValues] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [fetchedAnimals, setFetchedAnimals] = useState([]);
    const [fetchedAnimalsDropdownValues, setFetchedAnimalsDropdownValues] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState();
    const [selectedInspector, setSelectedInspector] = useState();
    const [selectedTestDate, setSelectedTestDate] = useState();

    const classes = useSelectStyles();
    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true)
            try {
                const { owners } = await getOwners();
                setFetchedOwners(owners);
                const dropdownValues = owners.map((owner) => ({
                    value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                    text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`
                }));
                setOwnersDropdownValues(dropdownValues);

                const { inspectors } = await getInspectors();
                setFetchedInspectors(inspectors);
                setInspectorsDropdownValues(inspectors.map((inspector) => ({
                    value: `${inspector?.lastName} ${inspector?.firstName}`,
                    text: `${inspector?.lastName} ${inspector?.firstName}`
                })))
            } catch (err) {
                error(err);
            }
            setIsLoading(false);
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    const ownerInspectorFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Μονάδα εκτροφής προβατίνας",
            required: true,
        },
        {
            customType: "dropdown",
            id: "inspector",
            items: inspectorsDropdownValues,
            placeholder: "Ελεγκτής Μέτρησης",
            required: true,
        },
        {
            customType: "date-picker",
            id: "testDate",
            type: "desktop",
            label: "Ημερομηνία Ελέγχου",
            width: "605px",
            background: "third",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Συνέχεια",
        },
    ]
    const gradeDropdownValues = [
        { text: 1, value: 1 },
        { text: 2, value: 2 },
        { text: 3, value: 3 },
        { text: 4, value: 4 },
        { text: 5, value: 5 },
        { text: 6, value: 6 },
        { text: 7, value: 7 },
        { text: 8, value: 8 },
        { text: 9, value: 9 },
        { text: 10, value: 10 },
    ];
    const udderCreateFormContent = [
        {
            customType: "dropdown",
            id: "animal",
            items: fetchedAnimalsDropdownValues,
            placeholder: "Επιλογή προβατίνας που ελέγχθηκε",
            required: true,
        },
        {
            customType: "dropdown",
            id: "depth",
            items: gradeDropdownValues,
            placeholder: "Βάθος Μαστού",
            required: true,
        },
        {
            customType: "dropdown",
            id: "teatAttachment",
            items: gradeDropdownValues,
            placeholder: "Πρόσφυση Μαστού",
            required: true,
        },
        {
            customType: "dropdown",
            id: "shape",
            items: gradeDropdownValues,
            placeholder: "Σχήμα Μαστού",
            required: true,
        },
        {
            customType: "dropdown",
            id: "position",
            items: gradeDropdownValues,
            placeholder: "Θέση Μαστού",
            required: true,
        },
        {
            customType: "dropdown",
            id: "size",
            items: gradeDropdownValues,
            placeholder: "Μέγεθος Μαστού",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή",
        },
    ]
    const handleOwnerInspectorSubmit = async (values) => {
        setIsLoading(true);
        const selOwner = fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.owner);
        const selInspector = fetchedInspectors.find((inspector) => `${inspector?.lastName} ${inspector?.firstName}` === values.inspector);

        setSelectedOwner(selOwner);
        setSelectedInspector(selInspector);
        setSelectedTestDate(values.testDate);

        const { success: scs, animals, message } = await getAnimalsByGender(selOwner._id, "female");
        if (scs) {
            setFetchedAnimals(animals);
            setFetchedAnimalsDropdownValues(animals.map((animal) => ({
                value: `${animal?.registrationCode}`,
                text: `${animal?.registrationCode}`
            })))
            setStep(2);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const handleCreateSubmit = async (values) => {
        setIsLoading(true);
        const animalId = fetchedAnimals.find((animal) => animal.registrationCode === values.animal)?._id;
        const valuesToSend = {
            owner: selectedOwner._id,
            inspector: selectedInspector._id,
            testDate: selectedTestDate,
            animal: animalId,
            depth: values.depth,
            teatAttachment: values.teatAttachment,
            shape: values.shape,
            position: values.position,
            size: values.size,
        };
        const { success: scs, message } = await addUdder(valuesToSend);
        if (scs) {
            success(message);
            setStep(1);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    {step === 1 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Εισαγωγή Στοιχείων Μορφολογίας Μαστού"}
                            </Typography>
                            <Form
                                content={ownerInspectorFormContent}
                                onSubmit={handleOwnerInspectorSubmit}
                                toResetForm={false}
                            />
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Εισαγωγή Στοιχείων Μορφολογίας Μαστού"}
                            </Typography>
                            <Form
                                content={udderCreateFormContent}
                                onSubmit={handleCreateSubmit}
                                toResetForm={false}
                            />
                            <Button
                                onClick={() => setStep(1)}
                                sx={{
                                    marginTop: "1rem",
                                    padding: "0.5rem 1rem",
                                    backgroundColor: "third",
                                    color: "secondary.main",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    variant: "h5",
                                }}
                            >
                                Πίσω
                            </Button>
                        </>
                    )}
                </Box>
            </Box>
        </>
    )
}

export default memo(UdderCreate)